import { render, staticRenderFns } from "./ItemDetails.vue?vue&type=template&id=a240b63e&"
import script from "./ItemDetails.vue?vue&type=script&lang=ts&"
export * from "./ItemDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports